import { render } from "./TestContextMenuPage.vue?vue&type=template&id=68101135"
import script from "./TestContextMenuPage.vue?vue&type=script&lang=js"
export * from "./TestContextMenuPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__